import React from 'react';

interface NewsModalProps {
    show: boolean;
    onClose: () => void;
}

const NewsModal: React.FC<NewsModalProps> = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-12 animate-in fade-in duration-300">
            <div className="relative w-full max-w-2xl rounded-xl overflow-hidden shadow-2xl border border-border-color bg-black flex flex-col animate-in zoom-in-95 duration-300">
                <div className="p-8">
                    <div className="text-xs font-semibold text-blue-600 mb-4 uppercase">CGM Sports News</div>
                    <h2 className="text-3xl font-bold text-white mb-4">Welcome to CGM Sports</h2>
                    <p className="text-gray-300 leading-relaxed mb-6">
                        CGM Sports is an AI-powered coaching dashboard that transforms wearable device data into actionable performance insights. 
                        Connect your devices, get real-time metrics, and receive AI-powered coaching recommendations.
                    </p>
                    <button
                        className="text-blue-400 hover:text-blue-300 transition-colors"
                        onClick={() => window.open('/services', '_blank')}
                    >
                        Learn more →
                    </button>
                </div>
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-3 right-3 z-10 p-2 rounded-full bg-black/60 hover:bg-black/80 text-white transition-all duration-300 ease-out hover:scale-110 focus:outline-none"
                    title="Close"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <button 
                className="fixed inset-0 w-full h-full cursor-default" 
                onClick={onClose} 
                tabIndex={-1} 
                aria-label="Close modal" 
                style={{ background: 'transparent', border: 'none', outline: 'none' }} 
            />
        </div>
    );
};

export default NewsModal;

